const ApiService = require('../../services/ApiService');

const state = () => ({
    wishListIds: [],
    wishListItems: [],
    inactiveVariationIds: [],
    isWishListInitiallyLoading: false,
    isLoading: false,
});

function updateStorage(state) {
    if (window.localStorage && state.wishListIds) {
        try {
            localStorage.setItem('wishListIds', window.ceresStore.getters.isLoggedIn ? '' : state.wishListIds.join(','));
        } catch (e) {
            console.error('error with local storage', e);
        }
    }
}

function loadFromStorage(state) {
    if (typeof window === 'undefined') {
        return [];
    }
    if (window.ceresStore.getters.isLoggedIn) {
        return [];
    }
    try {
        if (window.localStorage) {

            const ids = localStorage.getItem('wishListIds');
            if (ids) {
                return ids.split(',').map(id => parseInt(id));
            }
        }
    } catch (e) {
        console.error('error with local storage', e);
    }

    return [];
}


const mutations =
    {
        setWishListItems(state, wishListItems) {
            state.wishListItems = wishListItems;
        },

        setWishListIds(state, wishListIds) {
            state.wishListIds = wishListIds.map(Number);
            if (wishListIds.length > 0) {
                updateStorage(state);
            }
        },

        setInactiveVariationIds(state, inactiveVariationIds) {
            state.inactiveVariationIds = inactiveVariationIds?.map(Number);
        },

        removeWishListItem(state, wishListItem) {
            state.wishListItems = state.wishListItems.filter(item => item !== wishListItem);
        },

        removeWishListId(state, id) {
            state.wishListIds = state.wishListIds.filter(wishListId => wishListId !== id);
            updateStorage(state);
        },

        removeInactiveVariationId(state, id) {
            state.inactiveVariationIds = state.inactiveVariationIds.filter(inactiveVarationId => inactiveVarationId !== id);
        },

        addWishListItemToIndex(state, wishListItem, index) {
            state.wishListItems.splice(index, 0, wishListItem);
        },

        addWishListId(state, id) {
            state.wishListIds.push(id);
            updateStorage(state);
        },

        setIsWishListInitiallyLoading(state, value) {
            state.forceReload = value;
        },

        setIsWishListLoading(state, isLoading) {
            state.isLoading = !!isLoading;
        },
    };

let forceReload = false;
let count = 0;

const actions =
    {
        initWishListItems({ dispatch, commit, state }) {
            return new Promise((resolve, reject) => {
                if (!state.isWishListInitiallyLoading || forceReload && count < 2) {
                    commit('setIsWishListInitiallyLoading');
                    commit('setIsWishListLoading', true);
                    count++;
                    forceReload = false;

                    ApiService.get('/rest/io/itemWishList')
                              .done(async response => {
                                  commit('setInactiveVariationIds', response.inactiveVariationIds);
                                  commit('setWishListItems', response.documents);

                                  for (let id of state.inactiveVariationIds) {
                                      dispatch('removeWishListItem', { id, wishListItem: null, index: 0 });
                                  }

                                  if (state.wishListIds.length === 0) {
                                      const ids = loadFromStorage(state);
                                      // fallback recover wish list
                                      if (ids && ids.length > 0) {
                                          let promise = Promise.resolve();
                                          for (let id of ids) {
                                              promise = promise.then(() => dispatch('addToWishList', id)); // don't parallelize, will corrupt server data
                                          }
                                          await promise.catch(() => console.log('failed to restore wishlist'));
                                          forceReload = true;
                                          const data = await dispatch('initWishListItems');
                                          resolve(data);
                                          return;
                                      }
                                  }
                                  commit('setIsWishListLoading', false);
                                  resolve(response);
                              })
                              .fail(error => {
                                  commit('setIsWishListLoading', false);
                                  reject(error);
                              });
                } else {
                    resolve(state.wishListItems);
                }
            });
        },

        removeInactiveWishListItem({ commit }, { id }) {
            return new Promise((resolve, reject) => {
                ApiService.del('/rest/io/itemWishList/' + id)
                          .done(data => {
                              commit('removeWishListId', id);
                              commit('removeInactiveVariationId', id);
                              resolve(data);
                          })
                          .fail(error => {
                              reject(error);
                          })
                          .always(() => {
                              commit('setIsWishListLoading', false);
                          });
            });
        },

        removeWishListItem({ commit }, { id, wishListItem, index }) {
            return new Promise((resolve, reject) => {
                if (wishListItem) {
                    commit('removeWishListItem', wishListItem);
                }
                ApiService.del('/rest/io/itemWishList/' + id)
                          .done(data => {
                              commit('removeWishListId', id);
                              commit('removeInactiveVariationId', id);
                              resolve(data);
                          })
                          .fail(error => {
                              if (index) {
                                  commit('addWishListItemToIndex', wishListItem, index);
                              }
                              reject(error);
                          });
            });
        },

        addToWishList({ commit }, id) {
            return new Promise((resolve, reject) => {
                commit('addWishListId', id);
                ApiService.post('/rest/io/itemWishList', { variationId: id })
                          .done(data => {
                              resolve(data);
                          })
                          .fail(error => {
                              commit('removeWishListId', id);
                              reject(error);
                          });
            });
        },
    };

const getters =
    {
        wishListCount: state => state.wishListIds.length || loadFromStorage(state).length,
    };

export default {
    state,
    mutations,
    actions,
    getters,
};
